import React, { useEffect, useState } from 'react'
import { Container, Card, Spinner, Row, Col, Image, Badge, Button } from 'react-bootstrap'
import Cookies from 'js-cookie'
import d_log from 'loglevel'
import d_a_client from '../lib/auth0'
import api_utils from '../lib/api_utils'

function AfterLogin() {
  const [user, setUser] = useState(null)
  const [authCode, setAuthCode] = useState(null)
  const [loading, setLoading] = useState(true)

  const loadAuthData = async () => {
    setLoading(true)
    try {
      await d_a_client.init()
      const userInfo = await d_a_client.get_user()
      const code = await d_a_client.get_auth_code()

      setUser(userInfo)
      setAuthCode(code)

      // Set the auth code as a cookie once we have it
      if (code) {
        Cookies.set('ds_auth0_access_token', code, { expires: 60 })
        // Start session with backend after setting the cookie
        await api_utils.start_session()
      }
    } catch (error) {
      console.error('Error initializing auth:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    const initAuth = async () => {
      await loadAuthData()
    }

    initAuth()
  }, [])

  if (loading) {
    return (
      <Container className="text-center mt-5">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    )
  }

  return (
    <Container>
      <Card>
        <Card.Header className="d-flex justify-content-between align-items-center">
          <h3 className="mb-0">Welcome Back!</h3>
          <Button
            variant="primary"
            size="sm"
            onClick={loadAuthData}
            disabled={loading}
          >
            {loading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                Reloading...
              </>
            ) : (
              '🔄 Reload'
            )}
          </Button>
        </Card.Header>
        <Card.Body>
          {user ? (
            <Row>
              <Col md={4} className="text-center">
                {user.picture ? (
                  <Image
                    src={user.picture}
                    roundedCircle
                    style={{ width: '120px', height: '120px' }}
                    className="mb-3"
                  />
                ) : (
                  <div
                    className="rounded-circle bg-secondary d-flex align-items-center justify-content-center mx-auto mb-3"
                    style={{ width: '120px', height: '120px', fontSize: '48px', color: 'white' }}
                  >
                    👤
                  </div>
                )}
                {user.email_verified && (
                  <Badge bg="success" className="d-block">
                    Email Verified
                  </Badge>
                )}
              </Col>
              <Col md={8}>
                <h4 className="mb-3">Profile Information</h4>
                <div className="mb-2">
                  <strong>Name:</strong> {user.name || 'Not provided'}
                </div>
                <div className="mb-2">
                  <strong>Email:</strong> {user.email || 'Not provided'}
                </div>
                <div className="mb-2">
                  <strong>Nickname:</strong> {user.nickname || 'Not provided'}
                </div>
                {user.given_name && (
                  <div className="mb-2">
                    <strong>First Name:</strong> {user.given_name}
                  </div>
                )}
                {user.family_name && (
                  <div className="mb-2">
                    <strong>Last Name:</strong> {user.family_name}
                  </div>
                )}
                <div className="mb-2">
                  <strong>User ID:</strong> {user.sub || 'Not provided'}
                </div>
                {user.locale && (
                  <div className="mb-2">
                    <strong>Locale:</strong> {user.locale}
                  </div>
                )}
                <div className="mb-2">
                  <strong>Last Updated:</strong> {user.updated_at ? new Date(user.updated_at).toLocaleString() : 'Not provided'}
                </div>
                {authCode && (
                  <div className="mt-3">
                    <strong>Auth Code:</strong>
                    <code className="ms-2 text-break">{authCode}</code>
                  </div>
                )}
              </Col>
            </Row>
          ) : (
            <div className="text-center">
              <p>No user information available. Please try logging in again.</p>
            </div>
          )}
        </Card.Body>
      </Card>
    </Container>
  )
}

export default AfterLogin